import { render, staticRenderFns } from "./EmitterSettings.vue?vue&type=template&id=8c6de67e&lang=pug"
import script from "./EmitterSettings.vue?vue&type=script&lang=js"
export * from "./EmitterSettings.vue?vue&type=script&lang=js"
import style0 from "./EmitterSettings.vue?vue&type=style&index=0&id=8c6de67e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports